import React, { Component, Fragment } from "react";
import aggregacao from "../aggregacao";
import tiposFinanciamento from "../../../../constants/tiposFinanciamento";
import chartConfig from "../chartConfig";

const STYLE_SECAO = { textAlign: "center", backgroundColor: "#d6d8db", fontWeight: "400" };
const STYLE_SUBTOTAL = { backgroundColor: "#d6d8db", fontWeight: "600" };

export default class ResumoUniplan extends Component {

    linhaModalidade = (linha) => (
        <tr key={linha.modalidade}>
            <td className="text-left">{linha.modalidade}</td>
            {tiposFinanciamento.TIPOS.map(({ slug }) => (
                <td key={slug}>{chartConfig.formatarNumeroPtBr(linha[`matricula_${slug}`])}</td>
            ))}
            <td>{chartConfig.formatarNumeroPtBr(linha.matriculaTotal)}</td>
            {tiposFinanciamento.TIPOS.map(({ slug }) => (
                <td key={slug}>{chartConfig.formatarNumeroPtBr(linha[`hora_${slug}`])}</td>
            ))}
            <td>{chartConfig.formatarNumeroPtBr(linha.horaTotal)}</td>
        </tr>
    )

    linhaSubtotal = (linha) => (
        <tr key={linha.modalidade}>
            <td style={STYLE_SUBTOTAL}>{linha.modalidade}</td>
            {tiposFinanciamento.TIPOS.map(({ slug }) => (
                <td style={STYLE_SUBTOTAL} key={slug}>{chartConfig.formatarNumeroPtBr(linha[`matricula_${slug}`])}</td>
            ))}
            <td style={STYLE_SUBTOTAL}>{chartConfig.formatarNumeroPtBr(linha.matriculaTotal)}</td>
            {tiposFinanciamento.TIPOS.map(({ slug }) => (
                <td style={STYLE_SUBTOTAL} key={slug}>{chartConfig.formatarNumeroPtBr(linha[`hora_${slug}`])}</td>
            ))}
            <td style={STYLE_SUBTOTAL}>{chartConfig.formatarNumeroPtBr(linha.horaTotal)}</td>
        </tr>
    )

    render() {
        let { linhas, mes } = this.props;
        let resumo = aggregacao.resumoUniplan(linhas || [], mes);

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <h5>Resumo UNIPLAN</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered table-hover table-sm text-center">
                                <thead>
                                    <tr>
                                        <th rowSpan="2">Modalidades</th>
                                        <th colSpan={tiposFinanciamento.TIPOS.length + 1} scope="colgroup">Número de Matrículas</th>
                                        <th colSpan={tiposFinanciamento.TIPOS.length + 1} scope="colgroup">Hora Aluno (% evasão)</th>
                                    </tr>
                                    <tr>
                                        {tiposFinanciamento.LABELS.map((label) => <th key={`m-${label}`}>{label}</th>)}
                                        <th>Total</th>
                                        {tiposFinanciamento.LABELS.map((label) => <th key={`h-${label}`}>{label}</th>)}
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td colSpan={2 * (tiposFinanciamento.TIPOS.length + 1) + 1} style={STYLE_SECAO}>Educação Profissional</td></tr>
                                    {resumo.linhasEP.map(this.linhaModalidade)}
                                    {this.linhaSubtotal(resumo.totalEP)}

                                    <tr><td colSpan={2 * (tiposFinanciamento.TIPOS.length + 1) + 1} style={STYLE_SECAO}>Faculdade</td></tr>
                                    {resumo.linhasFaculdade.map(this.linhaModalidade)}
                                    {this.linhaSubtotal(resumo.totalFaculdade)}

                                    {this.linhaSubtotal(resumo.totalGeral)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
